import React from 'react';
import { useFadeInOnScroll } from '../../hooks/useScrollEffects';
import './NewsSection.css';

const NewsSection = () => {
  // Hooks para efeitos de scroll com layers sincronizados
  const { isVisible: titleVisible, elementRef: titleRef, transformStyle: titleTransform } = useFadeInOnScroll('TITLE');
  const { isVisible: cardsVisible, elementRef: cardsRef, transformStyle: cardsTransform } = useFadeInOnScroll('CONTENT');
  const { isVisible: ctaVisible, elementRef: ctaRef, transformStyle: ctaTransform } = useFadeInOnScroll('BUTTON');

  const scrollToHero = () => {
    const heroSection = document.getElementById('hero-section');
    if (heroSection) {
      heroSection.scrollIntoView({ behavior: 'smooth' });
    }
  };
  return (
    <section className="news-section" aria-label="Informações sobre mercado financeiro">
      <div className="news-container">
        <div className="news-content">
          <header className="news-header">
            <h2 
              ref={titleRef}
              className={`section-title scroll-fade-in ${titleVisible ? 'visible' : ''}`}
              style={titleTransform}
            >
              O MELHOR LUGAR PARA SE GANHAR DINHEIRO É<br /><span className="highlight-text">O MERCADO FINANCEIRO</span>
            </h2>
          </header>
          
          <div 
            ref={cardsRef}
            className={`news-cards scroll-fade-in ${cardsVisible ? 'visible' : ''}`}
            style={cardsTransform}
          >
            <div className="news-card">
              <img 
                src="https://cms.sbxtreinamentos.com.br/wp-content/uploads/2025/10/noticia-1.png" 
                alt="Notícia 1 - Mercado Financeiro"
                className="news-chart-image"
              />
            </div>
            
            <div className="news-card">
              <img 
                src="https://cms.sbxtreinamentos.com.br/wp-content/uploads/2025/10/noticia-2.png" 
                alt="Notícia 2 - Investimentos"
                className="news-investment-image"
              />
            </div>
          </div>
          
          <div className="news-description">
            <p className="section-text">
              Ano após ano a Bolsa de Valores apresenta resultados históricos e cada novo pico que parece ser o último, consegue ser superado 
              em alguns meses. No mercado financeiro, se a economia vai bem você ganha dinheiro, se a economia vai mal você ganha dinheiro. 
               <br /><br />
              <span className="highlight-text">Para quem sabe operar não há perdas, apenas lucros.</span>
              <br /><br />
              O problema é que a maioria não tem uma estratégia sólida, à prova de erros, para operar e cometem o erro de estarem sempre 
              jogando no limite. Por isso que eu quero abrir para vocês a estratégia que tem me feito lucrar dia após dia nos últimos 9 anos.
            </p>
          </div>
          
          <button 
            ref={ctaRef}
            className={`cta-button scroll-fade-in ${ctaVisible ? 'visible' : ''}`} 
            style={ctaTransform}
            onClick={scrollToHero}
          >
            Vagas Limitadas!
          </button>
        </div>
        
        <div className="background-blur-effects">
          <div className="dots-background">
            <img 
              src="https://api.builder.io/api/v1/image/assets/TEMP/bd2ca76f3b8afd5e2a3a88c8d7c8658968ba201c?width=2400" 
              alt=""
              className="dots-bg-left"
              aria-hidden="true"
            />
            <img 
              src="https://api.builder.io/api/v1/image/assets/TEMP/bd2ca76f3b8afd5e2a3a88c8d7c8658968ba201c?width=2400" 
              alt=""
              className="dots-bg-right"
              aria-hidden="true"
            />
          </div>

        </div>
      </div>
    </section>
  );
};

export default NewsSection;
